module.exports = __webpack_public_path__ + "static/media/paclgt4.48bf03cb.png";